
import  FundsSwitching  from '../../../../../assets/images/FundsSwitching.svg';
import FundsRedirecting from '../../../../../assets/images/FundsRedirecting.svg';
export const FUND_SWITCHING_TYPE = "FUND_SWITCHING_TYPE";
export const FUND_REDIRECTING_TYPE = "FUND_REDIRECTING_TYPE";
export const FUND_MANAGEMENT_CARD_DATA = [
    {
        title_en: "Fund / Strategy Switching",
        title_ar: "تحويل الأموال / الاستراتيجية",
        description: "Sell all or some of your policy's current fund/strategy holdings to buy other funds/select a different strategy.",
        description_ar: "قم ببيع جميع أو بعض الحصص من صندوق استثماراتك الحالية للاستثمار في صناديق / استراتيجيات أخرى.",
        id: "1",
        type: FUND_SWITCHING_TYPE,
        icon : FundsSwitching
    },
    {
        title_en: "Fund / Strategy Redirecting",
        title_ar: "إعادة توجيه الاشتراكات",
        description: "Select the funds/strategy where your future contributions will be invested. Your existing fund holdings will remain under the same fund/strategy previously selected.",
        description_ar: "حدد الصناديق/الاستراتيجية التي سيتم استثمار اشتراكاتك المستقبلية فيها. ستظل ممتلكات صندوقك الحالية كما هي.",
        id: "2",
        type: FUND_REDIRECTING_TYPE,
        icon : FundsRedirecting
    },

];
